import { css } from "emotion";
import { Component } from "preact";
import { route } from "preact-router";
import CMSComponent from "../../CMSComponent";
import LocationSearch from "./LocationSearch";

const eventNameSearch = css({
  maxWidth: 380,
  width: "100%",
  height: 40,
  borderTopLeftRadius: 4,
  fontSize: 16,
  borderBottomLeftRadius: 4,
  borderBottomRightRadius: 0,
  borderTopRightRadius: 0,
  border: "solid 1px #8D949E",
  borderRight: "none",
  paddingLeft: 16,
  "@media(max-width: 1000px)": {
    width: "auto"
  },
  "@media(max-width: 500px)": {
    width: 250,
    height: 36,
    verticalAlign: "top"
  }
});

const eventLocationSearch = css({
  width: 180,
  fontSize: 16,
  height: 40,
  border: "solid 1px #8D949E",
  borderRight: "none",
  borderBottomRightRadius: 0,
  borderTopRightRadius: 0,
  borderBottomLeftRadius: 0,
  borderTopLeftRadius: 0,
  paddingLeft: 28,
  backgroundImage: "url(../../../assets/ic_location_grey.svg)",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "4px 6px",
  verticalAlign: "top",
  "@media(max-width: 1000px)": {
    display: "none"
  }
});

const eventDateDropdown = css({
  appearance: "none",
  fontSize: 16,
  width: 140,
  height: 40,
  border: "solid 1px #8D949E",
  paddingLeft: 14,
  backgroundColor: "#FFFFFF",
  backgroundImage: "url(../../../assets/ic_dropdown.svg)",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "110px 8px",
  borderRadius: 0,
  borderStyle: "solid",
  borderColor: "#8D949E",
  borderBottomWidth: 1,
  verticalAlign: "top",
  option: {
    height: 40,
    fontSize: 16,
    background: "#f9f9fa"
  },
  "option:last-child": {
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4
  },
  "@media(max-width: 1000px)": {
    display: "none"
  }
});

const searchButton = css({
  width: 140,
  height: 40,
  borderTopRightRadius: 4,
  borderBottomRightRadius: 4,
  border: "none",
  color: "#fff",
  fontSize: 16,
  fontWeight: 600,
  cursor: "pointer",
  background: "#41157a",
  verticalAlign: "top",
  "@media(max-width: 500px)": {
    display: "none"
  }
});

const searchButtonMobile = css({
  display: "none",
  borderTopRightRadius: 4,
  borderBottomRightRadius: 4,
  border: "none",
  color: "#fff",
  cursor: "pointer",
  background: "#2074d9",
  verticalAlign: "top",
  "@media(max-width: 500px)": {
    display: "inline-block",
    height: 36,
    width: 36,
    backgroundImage: "url(../../../assets/ic_magnifying_glass_white.svg)",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "8px 8px",
    verticalAlign: "top"
  }
});

class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      location: "",
      latLng: { lat: "", lng: "" },
      timeframe: "all"
    };
    this.updateLocation = this.updateLocation.bind(this);
    this.updateTimeframe = this.updateTimeframe.bind(this);
    this.search = this.search.bind(this);
  }

  updateLocation(location, lat, lng) {
    this.setState({
      location: location,
      latLng: { lat, lng }
    });
  }

  updateTimeframe(event) {
    this.setState({
      timeframe: event.target.value
    });
  }

  search() {
    const { locale } = this.props;
    const { latLng, location, search, timeframe } = this.state;
    route(
      `/${locale}/search?lat=${latLng.lat}&lng=${
        latLng.lng
      }&location=${encodeURI(location)}&timeframe=${timeframe}&term=${encodeURI(
        this.searchTermInput.value
      )}`
    );
  }

  render() {
    return (
      <form style={{ verticalAlign: "top" }} onSubmit={this.search}>
        <input
          className={eventNameSearch}
          placeholder="Search Events"
          aria-label="Search Events"
          ref={ref => (this.searchTermInput = ref)}
        />
        <LocationSearch
          style={css(eventLocationSearch)}
          updateLocation={this.updateLocation}
          placeholder="Search Location"
        />
        <select
          className={eventDateDropdown}
          onChange={this.updateTimeframe}
          aria-label="Date"
        >
          <option value="all">All Dates</option>
          <option value="today">Today</option>
          <option value="tomorrow">Tomorrow</option>
          <option value="thisWeekend">This Weekend</option>
          <option value="thisWeek">This Week</option>
          <option value="nextWeek">Next Week</option>
        </select>
        <button
          className={searchButton}
          // onClick={this.search}
          aria-label="Search submit button"
        >
          Search
        </button>
        <button
          className={searchButtonMobile}
          // onClick={this.search}
          aria-label="Search submit button"
        />
      </form>
    );
  }
}

export default CMSComponent(null, SearchBar, 40);
